import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

export interface ytdSalesDataInterface {
  Gross_Units:number;
  Gross_Dollars:number;
  Returns_Units:number;
  Returns_Dollars:number;
  Net_Units:number;
  Net_Dollars:number;
  Sell_Through_YTD:number;
}

interface TitleListYTDState {
  data: ytdSalesDataInterface;
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
}
const initialState: TitleListYTDState = {
  data: {
    Gross_Units:0,
    Gross_Dollars:0,
    Returns_Units:0,
    Returns_Dollars:0,
    Net_Units:0,
    Net_Dollars:0,
    Sell_Through_YTD:0,
  },
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
};

export const FetchTitleListYTDSalesRecord = createAsyncThunk(
  "FetchTitleListYTDSalesRecord",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.YTDTITLESALESDATA,data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

const TitleListYTDSlice = createSlice({
  name: "TitleListYTDData",
  initialState,
  reducers: {
    clearYTDData: (state) => {
  state.data = initialState.data;
},
  },
  extraReducers(builder) {
    builder
      .addCase(FetchTitleListYTDSalesRecord.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(FetchTitleListYTDSalesRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.data = action.payload.data.totals;
      })
      .addCase(FetchTitleListYTDSalesRecord.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});

export const {clearYTDData
} = TitleListYTDSlice.actions;
export default TitleListYTDSlice.reducer;
